import axios from 'axios'
import dailyRecord from './dailyRecord'
import file from './file'
import errorRecord from './errorRecord'
import inspection from './inspection'
import payRecord from './payRecord'
import priceLibrary from './priceLibrary'
import project from './project'
import reviewApplication from './reviewApplication'
import testRecord from './testRecord'
import user from './user'
import member from './member'
import modules from './modules'
import schedule from './schedule'
import inspectionType from './inspectionType'
import _inspectionType from './_inspectionType'
import quantity from './quantity'
import bid from './bid'
import api from '../api/apiConfig'
import streamSaver from 'streamsaver'
import contract from './contract'
import progressReport from './progressReport'
import subscriber from './subscriber'
import pictureManagement from './pictureManagement'
import invitation from './invitation'

axios.interceptors.request.use(
  (req) => {
    if (req.method === 'put') {
      window.isDirty = true
    }
    if (project.state.currentProjectMember.type === 3 && (req.method === 'put' || req.method === 'patch' || req.method === 'delete' || req.method === 'post') && !req.interceptorsException) {
      return alert('您在此專案的權限為觀看者，操作失敗')
    }
    return req
  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    if (response.config.method === 'put') {
      window.isDirty = false
    }

    return response
  },
  (error) => {
    window.isDirty = false
    return Promise.reject(error)
  }
)

export default{
  state: {
    enumData: null,
    deviceType: {},
    httpError: ''
  },
  getters: {
    getEnumWord: state => (wordSet, valueEnum) => {
      if (valueEnum === undefined || valueEnum === null) return
      return Object.values(state.enumData[wordSet]).find(word => {
        return word.value === valueEnum
      }).word
    },
    thousandths: state => (value) => {
      if (value === null || value === '' || value === undefined) {
        return ''
      } else {
        value = Number.parseFloat(value).toFixed(2)
        value = value.indexOf('.') > -1 ? value : `${value}.00`
        return value.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
    }
  },
  mutations: {
    setDeviceType (state, deviceType) {
      state.deviceType = deviceType
    },
    setEnum (state, enumData) {
      state.enumData = enumData
    },
    setHttpError (state, httpError) {
      state.httpError = httpError
    }
  },
  actions: {
    async getEnum ({commit, getters}) {
      commit('setEnum', await api.getEnum())
    },
    async downloadFile ({commit}, {fileSrc, name}) {
      const stream = (await fetch(fileSrc, { cache: 'no-cache' })).body

      stream.pipeTo(streamSaver.createWriteStream(name))
    }
  },
  modules: {
    dailyRecord,
    file,
    errorRecord,
    payRecord,
    inspection,
    priceLibrary,
    project,
    reviewApplication,
    testRecord,
    user,
    member,
    modules,
    schedule,
    inspectionType,
    bid,
    quantity,
    contract,
    progressReport,
    subscriber,
    pictureManagement,
    _inspectionType,
    invitation
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js